import API from "../API";

export default class CLCreateService{

    static saveLadAcceptance(data) {
        return API.ax.post("land/ladApproval",data).catch(e=>{console.log(e);})
    }

}
